import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import WithdrawMoney from "../../components/Shop/WithdrawMoney";
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';

const ShopWithDrawMoneyPage = () => {
  return (
    <div className="shop-management-page">
    <DashboardHeader />
    <div className="shop-management-layout">
      <div className="shop-management-sidebar-slot">
        <DashboardSideBar active={17} />
      </div>
      <main className="shop-management-main-panel">
       <ShopManagementPageHero
        eyebrow="Wallet"
        title="Withdraw Money"
        copy="Review available balance, payout readiness, and request a shop cashout."
       />
       <WithdrawMoney />
      </main>
    </div>
  </div>
  )
}

export default ShopWithDrawMoneyPage